import React, {useState, useEffect} from "react";

import Box from '@mui/material/Box';

import "../App.css"
import {useAppCtx} from "../app/AppCtx";
import {useCrewCtx} from "../app/CrewCtx";
import {PageHeader} from "./PageHeader";
import {accessCtrl} from "../ctx/AccessCtrl"
import {CxDataGrid} from "../cmx/CxData";
import {CxGrid} from "../cmx/CxGrid";
import {Crew} from "../domain/Crew"
import {CxCaption} from "../cmx/CxTypography";
import {CxComboxSelection} from "../cmx/CxForm";

/**
 * CrewList with types: ["crew", "contractor"]
 */
export function CrewList({type}) {
    const {handleAction, getPageState, setPageState} = useAppCtx();
    const {crew, loadCrews, crewLoadCount} = useCrewCtx();

    useEffect(() => {
        loadCrews();
    }, []);

    // ----------------------------------------------------------------------------------------------------------------
    // header and view handling
    // ----------------------------------------------------------------------------------------------------------------

    const typeCfg = {
        crew : {
            title   : "Mitarbeiter",
            viewKey : "crewView",
            viewItems : [
                { label: "aktiv",   value: "activeView" },
                { label: "inaktiv", value: "inactiveView" },
            ],
            actionItems : [
                { kind: "icon", label: "Erstellen", iconName: "create", actionName: "crewCreate", disabled:!accessCtrl.canEditCrew }
            ],
            showAction: "crewShow",
            updateAction: "crewUpdate"
        },
        contractor : {
            title   : "Subunternehmer",
            viewKey : "contractorView",
            viewItems : [
                { label: "aktiv",   value: "activeView" },
                { label: "inaktiv", value: "inactiveView" },
            ],
            actionItems : [
                { kind: "icon", label: "Erstellen", iconName: "create", actionName: "contractorCreate", disabled:!accessCtrl.canEditCrew}
            ],
            showAction: "contractorShow",
            updateAction: "contractorUpdate"
        }
    };

    const cfg = typeCfg[type];                              // type ["crew", "contractor"]
    const view = getPageState('CrewList', cfg.viewKey);     // view ["activeView", "inactiveView"]

    const handleViewChange = (value) => {
        setPageState('CrewList', cfg.viewKey, value);
    };

    const renderHeader = () => {
        return (
            <PageHeader
                key={type}
                title={cfg.title}
                viewItems={cfg.viewItems}
                viewInitialValue={view}
                viewOnChangeHandler={handleViewChange}
                actionItems={cfg.actionItems}
            />
        );
    }

    // ----------------------------------------------------------------------------------------------------------------
    // control
    // ----------------------------------------------------------------------------------------------------------------

    const roleFilter = getPageState('CrewList', 'roleFilter');

    const handleRoleChange = (value) => {
        setPageState('CrewList', 'roleFilter', value);
    };

    const renderCtrlFilterRole = () => {
        return (
            <CxComboxSelection
                id="role"
                name="Rolle"
                value={roleFilter}
                onChange={handleRoleChange}
                items={Crew.getRoleSelection("operator", "Alle")}
            />
        );
    }

    const renderCtrl = () => {
        return (
            <CxGrid container spacing={2} direction="row">
                <CxGrid size="xl">
                    <CxGrid size="xl" sx={{marginTop: 1, marginBottom: 1}}>
                        <CxCaption>Filter</CxCaption>
                    </CxGrid>
                    <CxGrid size="xl" container spacing={2}>
                        <CxGrid size="sm">
                            { renderCtrlFilterRole()}
                        </CxGrid>
                        <CxGrid size="sm"></CxGrid>
                        <CxGrid size="lg"></CxGrid>
                    </CxGrid>
                </CxGrid>
            </CxGrid>
        );
    }

    // ----------------------------------------------------------------------------------------------------------------
    // filter view data from cache
    // ----------------------------------------------------------------------------------------------------------------

    const [rows, setRows] = useState([]);

    useEffect(() => {

        const roles = type === 'crew' ? Crew.getRolesBySelection(roleFilter) : ["contractor"];
        const active = view === 'activeView' ? 1 : 0;

        setRows( crew.filterByRolesAndActive(roles, active) );

    }, [view, type, roleFilter, crewLoadCount]);

    // ----------------------------------------------------------------------------------------------------------------
    // render view
    // ----------------------------------------------------------------------------------------------------------------

    const handleRowDoubleClick = (params) => {
        // return back to ['crew', 'contractor', 'team'] view after edit (is same as type)
        handleAction(cfg.showAction, params.row, type);
    };

    const handleEditClick = (params) => {
        // return back to ['crew', 'contractor', 'team'] view after edit (is same as type)
        handleAction(cfg.updateAction, params.row, type);
    }

    return (
        <Box sx={{ width: '100%' }}>
            <CxGrid container spacing={2}>

                { renderHeader() }
                { type === "crew" && renderCtrl() }

                <CxGrid size="xl">
                    <CxDataGrid
                        rows={rows}
                        columns={Crew.getListColumns(type, false)}
                        onRowDoubleClick={handleRowDoubleClick}
                        onViewAction={handleRowDoubleClick}
                        onEditAction={accessCtrl.canEditCrew ? handleEditClick : undefined} />
                </CxGrid>

            </CxGrid>
        </Box>
    );
}

// --------------------------------------------------------------------------------------------------------------------
// The end.